import { Modal } from "@sicredi/react";
import { IModalAccountAgency } from "./model";
import { useContext } from "react";
import { ContextAPI } from "#/contextProver/ContextProver";
import { handleRefresh } from "./services";

export const CapitalIntegralizadoModal: React.FC<IModalAccountAgency> = ({
  isOpen,
  setIsOpen,
}) => {
  const { logout } = useContext(ContextAPI);

  return (
    <div>
      <Modal
        title="Capital social não integralizado"
        onClose={async () => await handleRefresh(setIsOpen, logout)}
        show={isOpen}
        primaryButton={{
          children: "Entendi",
          onClick: async () => await handleRefresh(setIsOpen, logout),
        }}
      >
        Para contratar seu consórcio por aqui, é necessário ter o capital
        social integralizado. Entre em contato com sua agência. Enquanto
        isso, você pode fazer uma simulação.
      </Modal>
    </div>
  );
};
